import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { toast } from 'react-toastify';
import classnames from 'classnames';
import { connect } from 'react-redux';
import voca from 'voca';
import { Collapse, Nav, NavItem, NavLink } from 'reactstrap';
import * as actions from '../../../features/external-api/redux/actions';
import * as commonActions from '../../../features/common/redux/actions';
import ExternalSourceCollectionMapping from './ExternalSourceCollectionMapping';
import ExternalSourceFormTabBar from './ExternalSourceFormTabBar';
import { APP_WRITE, MYSQL, REST_API, ZAPIER } from 'drapcode-constant';
import { ErrorMessage, Field, Formik, Form } from 'formik';
import CustomSelect from '../../home/collections/CustomSelect';
import {
  processData,
  getFilteredArray,
  processMapping,
  populateTimeout,
  populateError,
  processErrorData,
  getFilteredErrorArray,
  parseJsonString,
  getNeedleListFromJsonObj,
  getNeedleMapFromJsonObj,
} from '../../../common/utils/rest_utils';
import { drapcodeIcon, iconForField } from '../../../common/custom/icon-library';
import {
  methodTypes,
  dynamicSort,
  formatJsonBody,
  formatJsonForPatch,
  snakeCaseToTitleCase,
  apiTypeImages,
} from '../../../common/utils/api_utils';
import ParentDocCard from '../../common/ParentDocCard';
import ParentContentCard from '../../common/ParentContentCard';
import CustomInputWithIcon from '../../../common/ui/CustomInputWithIcon';
import ShowResponseDataApi from '../../../common/ui/ShowResponseDataApi';
import CurrentUserResponseDataMapping from '../CurrentUserResponseDataMapping';
import MockDataModel from '../MockDataModel';
import CustomRadio from '../../../common/ui/CustomRadio';
import ExternalSourceInfo from './ExternalSourceInfo';
import ExportResponseFile from '../ExportResponseFile';
import ExternalApiError from '../error-timeout/ExternalApiError';
import TimeoutError from '../error-timeout/TimeoutError';
import RestAPICollectionFieldsModal from '../rest-api/RestAPICollectionFieldsModal';
import CardForMapping from '../CardForMapping';
import showAlert from '../../../common/utils/alert';
import DocsLink from '../../../common/custom/DocsLink';
import VideoBox from '../../../common/custom/VideoBox';
import CommonModalComponent from '../../common/CommonModalComponent';
import ExternalSourceResponseDataMapping from './ExternalSourceResponseDataMapping';
import FormFieldWithLabel from '../../common/FormFieldWithLabel';
import TooltipInfo from '../../../common/docs/TooltipInfo';
import { datasourceTypeLabel, getDatasourceName } from '../../../common/utils/data_source-util';

export class RestAPIExternalSourceForm extends Component {
  static propTypes = {
    externalapi: PropTypes.object.isRequired,
    actions: PropTypes.object.isRequired,
  };

  state = {
    externalApiName: '',
    url: '',
    methodType: 'POST',
    params: [],
    currentUserParams: [],
    bodyType: 'formData',
    bodyData: [],
    bodyRawData: '',
    bodyRawJSON: '',
    bodyCustomJSON: '',
    headers: [],
    authType: '',
    accessToken: '',
    requestHeader: '',
    nameError: '',
    urlError: '',
    bodyDataFrom: 'noDynamicData',
    statusPath: '',
    currentUserStatusPath: '',
    selectedCollectionName: '',
    selectedMapping: {},
    currentUserSelectedMapping: {},
    itemsPath: '',
    currentUserItemsPath: '',
    customPrimaryKey: '',
    currentUserPrimaryKey: '',
    collectionMapping: [{ id: 1, key: '', value: '' }],
    collectionName: '',
    isUpdateItemWithResponse: false,
    showModalForMockData: false,
    currentUserParamsValue: {},
    collectionParamsValue: {},
    showCurrentUserMapping: false,
    enableAuthorization: 'SAVE_TO_COLLECTION',
    donotPersistResponseData: false,
    processResponse: false,
    exportResponse: false,
    exportItemsPath: '',
    exportFileName: '',
    errorPath: '',
    errorValue: '',
    errorMsgPath: '',
    timeoutLimit: 0,
    timeoutMsg: '',
    generateCSV: 'DOWNLOAD_FILE_BYTES',
    processResponseDataMapping: 'SAVE_TO_COLLECTION',
    errorCollapse: false,
    timeoutCollapse: false,
    sendFormData: false,
    requestDataJsonType: 'DEFAULT',
    highlightFields: false,
    jsonEditor: '',
    showModalForCollectionFields: false,
    sendCollectionData: false,
    selectedCollection: {},
    bodyCollectionMapping: [{ id: 1, key: '', value: '' }],
    errors: [],
    timeout: { limit: 0, message: '' },
    externalApiType: '',
    showCollectionData: true,
    showmodal: false,
  };

  _isMounted = false;
  copiedTimeoutId = null;

  safeSetState = (updater, callback) => {
    if (this._isMounted) {
      this.setState(updater, callback);
    }
  };

  toggle = () => {
    this.setState({ showModalForMockData: !this.state.showModalForMockData });
  };

  toggleFieldsModal = () => {
    this.setState({ showModalForCollectionFields: !this.state.showModalForCollectionFields });
  };
  toggleModal = () => {
    this.setState({ showmodal: !this.state.showmodal });
  };
  async componentDidMount() {
    this._isMounted = true;
    const { externalApiId, externalapi, home, projectId, version, actions } = this.props;
    await actions.loadProjectDetail({ projectId, version });
    const { externalApiData } = externalapi;
    const { collections } = home ? home : '';
    const selectedCollection =
      externalApiData &&
      externalApiData.collectionName &&
      collections &&
      collections.find((collection) => {
        return collection.collectionName === externalApiData.collectionName;
      });
    if (!externalApiId || !externalApiData) {
      this.safeSetState({
        params: [{ id: 1, key: '', value: '' }],
        bodyData: [{ id: 1, key: '', value: '' }],
        headers: [{ id: 1, key: '', value: '' }],
        currentUserParams: [{ id: 1, key: '', value: '' }],
        errors: [{ id: 1, path: '', message: '', value: '' }],
        timeout: { limit: 0, message: '' },
      });
    } else {
      const {
        collectionMapping,
        setting,
        externalApiName,
        bodyDataFrom,
        sendFormData,
        responseDataMapping,
        bodyRawJSON,
        bodyCustomJSON,
        requestDataJsonType,
        bodyCollectionMapping,
        errors,
        timeout,
        externalApiType,
      } = externalApiData;
      let mapping = [];
      let collMapping = [];
      collectionMapping.map((e, i) => {
        const { type } = e;
        if (type === 'body') {
          mapping.push({
            id: i + 1,
            key: e.key,
            value: e.value,
          });
        } else if (
          [
            'collection-field',
            'derived-field',
            'reference-field',
            'project-constant',
            'collection-constant',
          ].includes(type)
        ) {
          collMapping.push({
            id: i + 1,
            key: e.key,
            value: JSON.stringify({ name: e.value, type: e.type }),
          });
        }
      });

      let selectedBodyCollectionMapping = [];
      if (bodyCollectionMapping && bodyCollectionMapping.length > 0) {
        selectedBodyCollectionMapping = bodyCollectionMapping.map(({ id, key, value }) => ({
          id: id ? id : 0,
          key: key ? key : '',
          value: value ? value : '',
        }));
      }
      selectedBodyCollectionMapping.push({
        key: '',
        value: '',
        id: selectedBodyCollectionMapping.length + 1,
      });

      let selectedParams = [];
      if (setting.params && setting.params.length > 0) {
        selectedParams = setting.params.map(({ id, key, value }) => ({
          id: id ? id : 0,
          key: key ? key : '',
          value: value ? value : '',
        }));
      }
      selectedParams.push({ key: '', value: '', id: selectedParams.length + 1 });
      let selectedHeaders = [];
      if (setting.headers && setting.headers.length > 0) {
        selectedHeaders = setting.headers.map(({ id, key, value }) => ({
          id: id ? id : 0,
          key: key ? key : '',
          value: value ? value : '',
        }));
      }
      selectedHeaders.push({ key: '', value: '', id: selectedHeaders.length + 1 });
      let selectedBodyMapping = [];
      if (mapping && mapping.length > 0) {
        selectedBodyMapping = [...mapping];
      }
      selectedBodyMapping.push({ key: '', value: '', id: selectedBodyMapping.length + 1 });
      let selErrors = populateError(responseDataMapping, errors);
      selErrors.push({ message: '', path: '', value: '', id: selErrors.length + 1 });
      let selTimeout = populateTimeout(responseDataMapping, timeout);
      selTimeout = {
        limit:
          selTimeout && Object.prototype.hasOwnProperty.call(selTimeout, 'limit')
            ? selTimeout.limit
            : 0,
        message:
          selTimeout && Object.prototype.hasOwnProperty.call(selTimeout, 'message')
            ? selTimeout.message
            : '',
      };
      this.safeSetState({
        params: selectedParams,
        headers: selectedHeaders,
        bodyData: selectedBodyMapping,
        authType: setting.authType,
        requestHeader: setting.requestHeader,
        accessToken: setting.accessToken,
        externalApiName: externalApiName,
        url: setting.url,
        methodType: setting.methodType,
        bodyDataFrom: bodyDataFrom,
        sendFormData: bodyDataFrom === 'collectionItemAndFormData' ? true : sendFormData,
        statusPath: responseDataMapping.statusPath,
        currentUserStatusPath: responseDataMapping.currentUserStatusPath,
        selectedCollectionName: responseDataMapping.selectedCollectionName,
        selectedMapping: responseDataMapping.selectedMapping
          ? responseDataMapping.selectedMapping
          : {},
        currentUserSelectedMapping: responseDataMapping.currentUserSelectedMapping
          ? responseDataMapping.currentUserSelectedMapping
          : {},
        itemsPath: responseDataMapping.itemsPath,
        currentUserItemsPath: responseDataMapping.currentUserItemsPath,
        enableAuthorization: responseDataMapping.enableAuthorization
          ? 'AUTHENTICATION'
          : 'SAVE_TO_COLLECTION',
        customPrimaryKey: responseDataMapping.customPrimaryKey,
        currentUserPrimaryKey: responseDataMapping.currentUserPrimaryKey,
        collectionMapping: collMapping.length ? collMapping : [{ id: 1, key: '', value: '' }],
        collectionName: externalApiData.collectionName,
        isUpdateItemWithResponse: externalApiData.isUpdateItemWithResponse,
        donotPersistResponseData: externalApiData.donotPersistResponseData,
        processResponse: responseDataMapping.selectedCollectionName
          ? true
          : responseDataMapping.processResponse
          ? responseDataMapping.processResponse
          : false,
        sendCollectionData: externalApiData.collectionName ? true : false,
        exportResponse: responseDataMapping.exportResponse,
        exportFileName: responseDataMapping.exportFileName,
        generateCSV: responseDataMapping.generateCSV,
        errorPath: responseDataMapping.errorPath,
        errorValue: responseDataMapping.errorValue,
        errorMsgPath: responseDataMapping.errorMsgPath,
        errors: selErrors,
        timeout: selTimeout,
        timeoutLimit: responseDataMapping.timeoutLimit,
        timeoutMsg: responseDataMapping.timeoutMsg,
        exportItemsPath: responseDataMapping.exportItemsPath,
        processResponseDataMapping: responseDataMapping.processResponseDataMapping
          ? responseDataMapping.processResponseDataMapping
          : 'SAVE_TO_COLLECTION',
        bodyRawJSON: bodyRawJSON,
        bodyCustomJSON: bodyCustomJSON,
        requestDataJsonType: requestDataJsonType ? requestDataJsonType : 'DEFAULT',
        highlightFields: !!bodyCustomJSON,
        selectedCollection: selectedCollection,
        bodyCollectionMapping: selectedBodyCollectionMapping,
        externalApiType: externalApiType,
      });
    }
  }

  componentWillUnmount() {
    this._isMounted = false;
    if (this.copiedTimeoutId) {
      clearTimeout(this.copiedTimeoutId);
      this.copiedTimeoutId = null;
    }
  }

  isValidationError = () => {
    const { externalApiName, url, nameError, urlError } = this.state;
    let isError = false;
    if (externalApiName === '' || !externalApiName) {
      this.setState({ nameError: 'This field is required' });
      isError = true;
    }
    if (externalApiName.length > 100) {
      this.setState({ nameError: 'Name can not be more than 100 characters' });
      isError = true;
    }
    if (url === '' || !url) {
      this.setState({ urlError: 'This field is required' });
      isError = true;
    }
    if (nameError || urlError) {
      isError = true;
    }
    return isError;
  };

  handleSubmit = () => {
    if (this.isValidationError()) {
      return;
    }
    const { projectId, version, externalApiId, externalapi } = this.props;
    const { externalApiData } = externalapi;
    const externalApiType = externalApiData ? externalApiData.externalApiType : REST_API;
    const {
      bodyType,
      bodyRawData,
      bodyData,
      headers,
      params,
      currentUserParams,
      authType,
      accessToken,
      requestHeader,
      methodType,
      url,
      externalApiName,
      statusPath,
      currentUserStatusPath,
      customPrimaryKey,
      currentUserPrimaryKey,
      selectedCollectionName,
      selectedMapping,
      currentUserSelectedMapping,
      itemsPath,
      currentUserItemsPath,
      collectionName,
      isUpdateItemWithResponse,
      donotPersistResponseData,
      bodyDataFrom,
      sendFormData,
      enableAuthorization,
      processResponse,
      exportResponse,
      exportItemsPath,
      exportFileName,
      generateCSV,
      processResponseDataMapping,
      bodyRawJSON,
      bodyCustomJSON,
      requestDataJsonType,
      sendCollectionData,
      bodyCollectionMapping,
      errors,
      timeout,
    } = this.state;
    let bodyTypeData = getFilteredArray(bodyData);
    const { collectionMapping } = this.state;
    let collectionMappingObject = processMapping(collectionMapping);
    bodyTypeData.forEach((e) => {
      collectionMappingObject.push({
        key: e.key,
        value: e.value,
        type: 'body',
        description: e.description,
      });
    });
    let formData = {
      projectId,
      version,
      collectionName,
      externalApiName,
      externalApiType,
      bodyDataFrom,
      sendFormData,
      isUpdateItemWithResponse,
      collectionMapping: collectionMappingObject,
      donotPersistResponseData: donotPersistResponseData,
      processResponse,
      processResponseDataMapping: processResponseDataMapping,
      bodyRawJSON,
      bodyCustomJSON,
      requestDataJsonType,
      sendCollectionData,
      bodyCollectionMapping: getFilteredArray(bodyCollectionMapping),
      errors: getFilteredErrorArray(errors),
      timeout,
    };
    formData.responseDataMapping = {
      statusPath,
      currentUserStatusPath,
      customPrimaryKey,
      currentUserPrimaryKey,
      selectedCollectionName,
      selectedMapping,
      currentUserSelectedMapping,
      itemsPath,
      currentUserItemsPath,
      enableAuthorization: enableAuthorization === 'AUTHENTICATION',
      processResponse,
      exportResponse,
      exportFileName,
      exportItemsPath,
      generateCSV,
      processResponseDataMapping,
    };
    //Save Mock Data in below json
    formData.setting = {
      methodType,
      url,
      headers: getFilteredArray(headers),
      params: getFilteredArray(params),
      currentUserParams: getFilteredArray(currentUserParams),
      authType: authType,
      accessToken: accessToken,
      requestHeader: voca.trim(requestHeader),
      body: {
        type: bodyType,
        data: bodyType === 'raw' ? bodyRawData : getFilteredArray(bodyData),
      },
    };
    const sourceType = externalApiType ? externalApiType.toLowerCase() : '';
    if (externalApiId) {
      formData.externalApiId = externalApiId;
      this.props.actions.updateExternalApi(formData).then(() => {
        this.props.history.push(`/2.0/externalapi/${version}/v/${projectId}/${sourceType}`);
      });
    } else {
      this.props.actions.createExternalApi(formData).then(() => {
        this.props.history.push(`/2.0/externalapi/${version}/v/${projectId}/${sourceType}`);
      });
    }
  };

  handleChange = (e) => {
    let { name, value } = e.target;
    let nameError,
      urlError = '';
    if (name === 'externalApiName') {
      nameError = value.length > 100 ? 'Name can not be more than 100 characters' : '';
    }
    this.setState({ [name]: value, nameError, urlError });
  };

  handleResponseDataChange = (name, value) => {
    if (name === 'isUpdateItemWithResponse') {
      let selectedCollectionName = '';
      if (value) {
        selectedCollectionName = this.state.collectionName;
      }
      this.setState({ [name]: value, selectedCollectionName });
    } else {
      this.setState({ [name]: value });
    }
  };

  handleCollectionFormChange = (name, value) => {
    if (name === 'selectedCollectionName') {
      this.setState({ collectionName: value });
    } else {
      this.setState({ [name]: value });
    }
  };

  createNewParamRow = (rowObj) => {
    const params = processData(this.state.params, rowObj);
    this.setState({ params });
  };

  createNewErrorRow = (rowObj) => {
    const errors = processErrorData(this.state.errors, rowObj);
    this.setState({ errors });
  };

  createNewParamRowForUser = (rowObj) => {
    const currentUserParams = processData(this.state.currentUserParams, rowObj);
    this.setState({ ...this.state, currentUserParams });
  };

  handleBodyData = (rowObj) => {
    const bodyData = processData(this.state.bodyData, rowObj);
    this.setState({ bodyData });
  };

  handleHeaderChange = (rowObj) => {
    const headers = processData(this.state.headers, rowObj);
    this.setState({ headers });
  };

  selectBodyDataFrom = (name, status) => {
    this.setState({ [name]: status });
  };

  toggleSendFormData = (event) => {
    const { name, checked } = event.target;
    this.setState({ [name]: checked });
  };

  handleAuthData = (e) => {
    const { name, value } = e.target;
    if (name && name.startsWith('timeout.')) {
      const timeoutKey = name.split('.')[1];
      this.setState((prevState) => ({
        timeout: {
          ...(prevState.timeout || { limit: 0, message: '' }),
          [timeoutKey]: value,
        },
      }));
      return;
    }
    this.setState({ [name]: value });
  };

  handleRawData = (e) => {
    this.setState({ bodyRawData: e.target.value });
  };

  sendTestRequest = () => {
    this.setState({ showModalForMockData: true });
  };

  handleMockValueSubmit = () => {
    const {
      methodType,
      headers,
      url,
      params,
      currentUserParams,
      bodyData,
      authType,
      accessToken,
      requestHeader,
      currentUserParamsValue,
      collectionParamsValue,
      bodyDataFrom,
      bodyRawJSON,
      bodyCustomJSON,
      errors,
      timeout,
      requestDataJsonType,
      externalApiType,
    } = this.state;
    console.log('%c==> handleMockValueSubmit this.state :>> ', 'color:lime', this.state);
    const { actions, projectId, version } = this.props;
    const bodyDataForRequest = [...bodyData];
    if (methodType !== 'GET') {
      collectionParamsValue &&
        Object.entries(collectionParamsValue).map(([key, value], index) => {
          const collectionParamsValueObj = {
            id: ++index,
            key,
            value,
          };
          bodyDataForRequest.push(collectionParamsValueObj);
        });
    }
    let bodyRawOrCustomJSON = {};
    if (bodyDataFrom === 'RAW_JSON') {
      let jsonString = '';
      if (bodyRawJSON && bodyRawJSON.includes("'")) {
        jsonString = bodyRawJSON.replaceAll("'", '"');
        jsonString = JSON.stringify(jsonString);
      } else {
        jsonString = JSON.stringify(bodyRawJSON);
      }

      let jsonObj = jsonString ? JSON.parse(parseJsonString(jsonString)) : '';
      bodyRawOrCustomJSON = jsonObj;
    } else if (bodyDataFrom === 'collectionItem' && requestDataJsonType === 'CUSTOM') {
      let jsonString = '';
      if (bodyCustomJSON && bodyCustomJSON.includes("'")) {
        jsonString = bodyCustomJSON.replaceAll("'", '"');
        jsonString = JSON.stringify(jsonString);
      } else {
        jsonString = JSON.stringify(bodyCustomJSON);
      }

      let jsonObj = jsonString ? JSON.parse(parseJsonString(jsonString)) : '';
      bodyRawOrCustomJSON = jsonObj;
    }

    let finalData = {
      methodType,
      projectId,
      version,
      url: url,
      headers: getFilteredArray(headers),
      params: getFilteredArray(params),
      currentUserParams: getFilteredArray(currentUserParams),
      errors: getFilteredErrorArray(errors),
      timeout,
      body: {
        type: bodyDataFrom,
        requestType: requestDataJsonType,
        data:
          bodyDataFrom === 'RAW_JSON' ||
          (bodyDataFrom === 'collectionItem' && requestDataJsonType === 'CUSTOM')
            ? bodyRawOrCustomJSON
            : getFilteredArray(bodyDataForRequest),
      },
      authType,
      accessToken,
      requestHeader,
      currentUserParamsValue,
      collectionParamsValue,
    };
    if (externalApiType === APP_WRITE && methodType === `POST`) {
      finalData.body = formatJsonBody(finalData);
    }
    if (externalApiType === APP_WRITE && methodType === `PATCH`) {
      finalData = formatJsonForPatch(finalData);
    }
    actions.sendMockDataRequest(finalData).then(() => {
      this.safeSetState({ showModalForMockData: false });
    });
  };

  handleMockValueChange = (event) => {
    const { name, value } = event.target;
    this.setState((prevState) => ({
      currentUserParamsValue: {
        ...prevState.currentUserParamsValue,
        [name]: value,
      },
    }));
  };

  handleMockCollectionValueChange = (event) => {
    const { name, value } = event.target;
    this.setState((prevState) => ({
      collectionParamsValue: {
        ...prevState.collectionParamsValue,
        [name]: value,
      },
    }));
  };

  handleCheckboxChange = (event) => {
    const { name, checked } = event.target;

    if (name === 'processResponse') {
      if (checked) {
        this.setState({
          [name]: checked,
          enableAuthorization: 'SAVE_TO_COLLECTION',
          processResponseDataMapping: 'SAVE_TO_COLLECTION',
        });
      } else {
        this.setState({
          [name]: checked,
          selectedCollectionName: '',
          enableAuthorization: '',
          processResponseDataMapping: 'SAVE_TO_COLLECTION',
          donotPersistResponseData: false,
          currentUserSelectedMapping: {},
          selectedMapping: {},
        });
      }
    } else if (name === 'sendCollectionData') {
      if (checked) {
        this.setState({
          [name]: checked,
          collectionName: '',
          bodyDataFrom: 'collectionItem',
        });
      } else {
        const { collectionName, collectionMapping } = this.state;
        const hasCollectionMapping = !!collectionName && !!collectionMapping;
        const showConfirmation = !!hasCollectionMapping;
        if (showConfirmation) {
          const confirmationMsg = `The existing collection field mapping (if any) will be removed. Do you want to proceed?`;
          const preConfirm = () => {
            this.setState({
              [name]: checked,
              collectionName: '',
              bodyDataFrom: 'noDynamicData',
            });
            this.handleBodyCustomJSON('');
            this.handleCollectionFormChange('collectionMapping', []);
            this.handleCollectionFormChange('collectionMapping', [{ id: 1, key: '', value: '' }]);
          };
          showAlert(confirmationMsg, preConfirm, 'Proceed');
        } else {
          this.setState({
            [name]: checked,
            collectionName: '',
            bodyDataFrom: 'noDynamicData',
          });
        }
      }
    } else {
      this.setState({ [name]: checked });
    }
  };

  handleRadioChange = (event) => {
    const { name, value } = event.target;
    if (name === 'processResponseDataMapping') {
      if (['SAVE_TO_COLLECTION', 'AUTHENTICATION'].includes(value)) {
        const enableAuthorizationValue =
          value === 'SAVE_TO_COLLECTION' ? 'SAVE_TO_COLLECTION' : 'AUTHENTICATION';
        this.setState({
          [name]: value,
          enableAuthorization: enableAuthorizationValue,
          donotPersistResponseData: false,
        });
      } else if (value === 'DO_NOT_PERSIST_DATA') {
        this.setState({
          [name]: value,
          enableAuthorization: 'SAVE_TO_COLLECTION',
          donotPersistResponseData: true,
          currentUserSelectedMapping: {},
        });
      } else {
        this.setState({
          [name]: value,
          enableAuthorization: 'SAVE_TO_COLLECTION',
          donotPersistResponseData: false,
        });
      }
    } else {
      this.setState({ [name]: value });
    }
  };

  handleProcessResponseMappingNav = (name, value) => {
    if (name === 'processResponseDataMapping') {
      if (['SAVE_TO_COLLECTION', 'AUTHENTICATION'].includes(value)) {
        const enableAuthorizationValue =
          value === 'SAVE_TO_COLLECTION' ? 'SAVE_TO_COLLECTION' : 'AUTHENTICATION';
        this.setState({
          [name]: value,
          enableAuthorization: enableAuthorizationValue,
          donotPersistResponseData: false,
        });
      } else if (value === 'DO_NOT_PERSIST_DATA') {
        this.setState({
          [name]: value,
          enableAuthorization: 'SAVE_TO_COLLECTION',
          donotPersistResponseData: true,
          currentUserSelectedMapping: {},
        });
      } else {
        this.setState({
          [name]: value,
          enableAuthorization: 'SAVE_TO_COLLECTION',
          donotPersistResponseData: false,
        });
      }
    }
  };

  handleBodyRawJSON = (e) => {
    if (e.target) {
      this.setState({ bodyRawJSON: e.target.value });
    } else {
      this.setState({ bodyRawJSON: e ? e : '' });
    }
  };

  handleBodyCustomJSON = (e) => {
    if (e.target) {
      this.setState({ bodyCustomJSON: e.target.value });
    } else {
      this.setState({ bodyCustomJSON: e ? e : '' });
    }
  };

  handleJsonEditor = (editor) => {
    this.setState({ jsonEditor: editor });
  };

  toggleHighlightFields = (jsonEditor, type) => {
    // TODO: Need to check if highlightFields can be enabled based on values
    const doHighlightFields = !this.state.highlightFields;
    this.setState({
      highlightFields: doHighlightFields,
      jsonEditor,
    });
  };

  enableAuthentication = () => {
    const { processResponse, processResponseDataMapping } = this.state;
    if (processResponse) {
      return (
        <>
          <div className="row col-12 pb-2">
            <Nav pills className="nav-pills-primary drapcode-nav-pills">
              {processResponseDataMapping === 'AUTHENTICATION' ? (
                <NavItem>
                  <NavLink
                    className={classnames({
                      active: processResponseDataMapping === 'AUTHENTICATION',
                    })}
                    title={'We will login and/or regiter the user with the response from API.'}
                    onClick={() => {
                      this.handleProcessResponseMappingNav(
                        'processResponseDataMapping',
                        'AUTHENTICATION',
                      );
                    }}
                  >
                    <i className="material-icons">account_circle</i> Login/Signup with Response Data
                  </NavLink>
                </NavItem>
              ) : (
                <NavItem>
                  <NavLink
                    className={classnames({
                      active: processResponseDataMapping === 'DO_NOT_PERSIST_DATA',
                    })}
                    title={'It will not save record in collection data.'}
                    onClick={() => {
                      this.handleProcessResponseMappingNav(
                        'processResponseDataMapping',
                        'DO_NOT_PERSIST_DATA',
                      );
                    }}
                  >
                    <i className="material-icons">cloud_queue</i> Map Response Data{' '}
                    <span>(without saving)</span>
                  </NavLink>
                </NavItem>
              )}
            </Nav>
          </div>
        </>
      );
    } else {
      return '';
    }
  };

  showResponseMappingOptions = () => {
    const { processResponse, exportResponse, processResponseDataMapping } = this.state;
    return (
      <>
        <div className="col-12">
          <div className="row col-12">
            <div className="col-md-4">
              <div className="form-check">
                <CustomRadio label="Process Response" isRadio={false}>
                  <input
                    name="processResponse"
                    type="checkbox"
                    className="form-check-input"
                    checked={processResponse}
                    onChange={this.handleCheckboxChange}
                  />
                </CustomRadio>
                <br />
                <small>( We will process the response data. [Default: Do Nothing] )</small>
              </div>
            </div>
            <div className="col-md-4">
              {processResponseDataMapping === 'AUTHENTICATION' ? (
                ''
              ) : (
                <div className="form-check">
                  <CustomRadio label="Export Response File" isRadio={false}>
                    <input
                      name="exportResponse"
                      type="checkbox"
                      className="form-check-input"
                      checked={exportResponse}
                      onChange={this.handleCheckboxChange}
                    />
                  </CustomRadio>
                  <br />
                  <small>( We will export the response data to a file. )</small>
                </div>
              )}
            </div>
          </div>
        </div>
      </>
    );
  };

  showMockDataMapping = () => {
    const {
      currentUserParams,
      showModalForMockData,
      collectionMapping,
      bodyCollectionMapping,
      url,
      bodyDataFrom,
      bodyRawJSON,
      bodyCustomJSON,
      requestDataJsonType,
    } = this.state;
    const urlKeyMapping = [];
    const urlKeyList =
      url &&
      url.match(/{{(.*?)}}/g) &&
      url.match(/{{(.*?)}}/g).map((b) => b.replace(/{{(.*?)}}/g, '$1'));
    urlKeyList &&
      urlKeyList.map((key, index) => {
        const urlKeyObj = { id: ++index, key, value: key };
        urlKeyMapping.push(urlKeyObj);
      });

    let jsonObjNeedleKeyMapping = [];
    if (bodyDataFrom === 'collectionItem' && requestDataJsonType === 'CUSTOM') {
      jsonObjNeedleKeyMapping = getNeedleMapFromJsonObj(bodyCustomJSON);
    } else if (bodyDataFrom === 'RAW_JSON' && requestDataJsonType === 'DEFAULT') {
      jsonObjNeedleKeyMapping = getNeedleMapFromJsonObj(bodyRawJSON);
    }

    if (
      (currentUserParams && currentUserParams.length > 0) ||
      (collectionMapping && collectionMapping.length > 0) ||
      (bodyCollectionMapping && bodyCollectionMapping.length > 0) ||
      (urlKeyMapping && urlKeyMapping.length > 0) ||
      (jsonObjNeedleKeyMapping && jsonObjNeedleKeyMapping.length > 0)
    ) {
      if (
        (currentUserParams[0] && currentUserParams[0].key && currentUserParams[0].value) ||
        (collectionMapping[0] && collectionMapping[0].key && collectionMapping[0].value) ||
        (bodyCollectionMapping[0] &&
          bodyCollectionMapping[0].key &&
          bodyCollectionMapping[0].value) ||
        (urlKeyMapping[0] && urlKeyMapping[0].key) ||
        (jsonObjNeedleKeyMapping[0] && jsonObjNeedleKeyMapping[0].key)
      ) {
        return (
          <MockDataModel
            showModalForMockData={showModalForMockData}
            toggle={this.toggle}
            currentUserParams={currentUserParams}
            handleMockValueChange={this.handleMockValueChange}
            collectionMapping={collectionMapping}
            bodyCollectionMapping={bodyCollectionMapping}
            urlKeyMapping={urlKeyMapping}
            bodyDataFrom={bodyDataFrom}
            requestDataJsonType={requestDataJsonType}
            jsonObjNeedleKeyMapping={jsonObjNeedleKeyMapping}
            handleMockCollectionValueChange={this.handleMockCollectionValueChange}
            handleMockValueSubmit={this.handleMockValueSubmit}
          />
        );
      }
    }
  };

  showSendRequestOrMockData = () => {
    const {
      currentUserParams,
      collectionMapping,
      bodyCollectionMapping,
      url,
      bodyDataFrom,
      bodyRawJSON,
      bodyCustomJSON,
      requestDataJsonType,
    } = this.state;
    const urlKeyList =
      url &&
      url.match(/{{(.*?)}}/g) &&
      url.match(/{{(.*?)}}/g).map((b) => b.replace(/{{(.*?)}}/g, '$1'));

    let jsonObjNeedlelist = [];
    if (bodyDataFrom === 'collectionItem' && requestDataJsonType === 'CUSTOM') {
      jsonObjNeedlelist = getNeedleListFromJsonObj(bodyCustomJSON, jsonObjNeedlelist);
    } else if (bodyDataFrom === 'RAW_JSON' && requestDataJsonType === 'DEFAULT') {
      jsonObjNeedlelist = getNeedleListFromJsonObj(bodyRawJSON, jsonObjNeedlelist);
    }

    let showMockData = false;
    if (
      (currentUserParams && currentUserParams.length > 0) ||
      (collectionMapping && collectionMapping.length > 0) ||
      (bodyCollectionMapping && bodyCollectionMapping.length > 0) ||
      (urlKeyList && urlKeyList.length > 0) ||
      (jsonObjNeedlelist && jsonObjNeedlelist.length > 0)
    ) {
      if (
        (currentUserParams[0] && currentUserParams[0].key && currentUserParams[0].value) ||
        (collectionMapping[0] && collectionMapping[0].key && collectionMapping[0].value) ||
        (bodyCollectionMapping[0] &&
          bodyCollectionMapping[0].key &&
          bodyCollectionMapping[0].value) ||
        (urlKeyList && urlKeyList.length > 0) ||
        (jsonObjNeedlelist && jsonObjNeedlelist.length > 0)
      ) {
        showMockData = true;
      }
    }
    if (showMockData) {
      return (
        <div className="col-12 text-right">
          <button className="btn btn-theme-submit" onClick={this.sendTestRequest}>
            <i className={`wb ${drapcodeIcon(REST_API)}`}></i>
            &nbsp;Add Mock Data & Send Request&nbsp;
          </button>
        </div>
      );
    } else {
      return (
        <div className="col-12 text-right">
          <button className="btn btn-theme-submit" onClick={this.handleMockValueSubmit}>
            <i className={`wb ${drapcodeIcon(REST_API)}`}></i>
            &nbsp;Send Request&nbsp;
          </button>
        </div>
      );
    }
  };

  collectionsOptions = () => {
    const { collections } = this.props.home;
    let collectionsToSelect = [];
    if (collections && collections.length > 0) {
      collectionsToSelect = [...collections].sort(dynamicSort('collectionTitle')).map((e) => ({
        label: e.collectionTitle,
        value: e.collectionName,
      }));
    }
    return [...collectionsToSelect];
  };

  handleCollectionChange = (event) => {
    const { collectionMapping, bodyCustomJSON, bodyCollectionMapping } = this.state;
    const { home } = this.props;
    const { collections } = home ? home : '';
    const collectionName = event.target.value;
    const selectedCollection = collections.find((collection) => {
      return collection.collectionName === collectionName;
    });
    const hasCollectionMapping = !!(
      collectionMapping &&
      collectionMapping.length > 0 &&
      collectionMapping[0].key
    );
    const hasBodyCollectionMapping = !!(
      bodyCollectionMapping &&
      bodyCollectionMapping.length > 0 &&
      bodyCollectionMapping[0].key
    );
    const showConfirmation = !!(bodyCustomJSON || hasCollectionMapping || hasBodyCollectionMapping);
    const isPersistentCollection = !!selectedCollection.willPersist;
    let bodyDataFrom = isPersistentCollection ? 'collectionItem' : 'NON_PERSISTENT_COLLECTION';
    if (!selectedCollection) {
      bodyDataFrom = 'noDynamicData';
    }
    if (showConfirmation) {
      const confirmationMsg = `The existing ${
        (hasCollectionMapping || hasBodyCollectionMapping) && bodyCustomJSON
          ? 'field mapping and Custom JSON'
          : (hasCollectionMapping || hasBodyCollectionMapping) && !bodyCustomJSON
          ? 'field mapping'
          : !hasCollectionMapping && !hasBodyCollectionMapping && bodyCustomJSON
          ? 'Custom JSON'
          : ''
      } will be removed. Do you want to proceed?`;

      const preConfirm = () => {
        this.setState({ selectedCollection, bodyDataFrom });
        this.handleBodyCustomJSON('');
        this.handleCollectionFormChange('collectionMapping', []);
        this.handleCollectionFormChange('collectionMapping', [{ id: 1, key: '', value: '' }]);
        this.handleCollectionFormChange('bodyCollectionMapping', []);
        this.handleCollectionFormChange('bodyCollectionMapping', [{ id: 1, key: '', value: '' }]);
        this.handleCollectionFormChange('selectedCollectionName', collectionName);
      };
      showAlert(confirmationMsg, preConfirm, 'Proceed');
    } else {
      this.setState({ selectedCollection, bodyDataFrom });
      this.handleCollectionFormChange('selectedCollectionName', collectionName);
    }
  };

  showCurrentUserMapping = () => {
    const {
      showCurrentUserMapping,
      currentUserStatusPath,
      currentUserItemsPath,
      currentUserSelectedMapping,
      collectionName,
      enableAuthorization,
      currentUserPrimaryKey,
    } = this.state;

    if (showCurrentUserMapping || enableAuthorization === 'AUTHENTICATION') {
      return (
        <div className="col-12">
          <CurrentUserResponseDataMapping
            handleChange={this.handleResponseDataChange}
            statusPath={currentUserStatusPath}
            itemsPath={currentUserItemsPath}
            selectedMapping={currentUserSelectedMapping}
            currentUserPrimaryKey={currentUserPrimaryKey}
          />
        </div>
      );
    }
  };

  copyToClipboard = () => {
    this.safeSetState({
      copied: true,
      showModalForCollectionFields: !this.state.showModalForCollectionFields,
    });
    toast.success('Copied to clipboard');
    if (this.copiedTimeoutId) {
      clearTimeout(this.copiedTimeoutId);
    }
    this.copiedTimeoutId = setTimeout(() => {
      this.safeSetState({ copied: false });
      this.copiedTimeoutId = null;
    }, 2000);
  };

  insertTextToUrlInput = (textToInsert) => {
    if (textToInsert) {
      const urlInputElem = document.getElementById('url');
      let start = urlInputElem.selectionStart;
      // obtain the index of the last selected character
      let finish = urlInputElem.selectionEnd;
      //obtain all Text
      let allText = urlInputElem.value;
      // obtain the selected text
      let sel = allText.substring(start, finish);
      let newText = '';
      if (sel) {
        newText = allText.replace(sel, textToInsert);
      } else {
        newText = allText + textToInsert;
      }
      this.setState({
        showModalForCollectionFields: !this.state.showModalForCollectionFields,
        url: newText,
      });
      toast.success('Inserted into URL');
    }
  };

  showCollectionFieldModal = () => {
    const { collectionName, bodyDataFrom } = this.state;
    const { externalapi, common } = this.props;
    const { collections } = externalapi ? externalapi : '';
    const { projectDetail } = common ? common : '';
    const selectedCollection =
      collectionName &&
      collections &&
      collections.find((collection) => {
        return collection.collectionName === collectionName;
      });

    return (
      <RestAPICollectionFieldsModal
        selectedCollection={selectedCollection}
        collections={collections}
        projectDetail={projectDetail}
        copyToClipboard={this.copyToClipboard}
        insertTextToEditor={this.insertTextToUrlInput}
        toggleFields={this.state.showModalForCollectionFields}
        toggleFieldsModal={this.toggleFieldsModal}
        bodyDataFrom={bodyDataFrom}
      />
    );
  };
  handleExternalApiType = async (valuse) => {
    const { version, externalApiId, projectId, actions, history } = this.props;
    const { externalDataSource } = valuse;
    const ds = [REST_API, ZAPIER];
    const data = { externalApiType: externalDataSource.value, projectId };
    await actions.updateExternalApiType({ version, projectId, externalApiId, data });
    this.toggleModal();
    if (ds.includes(externalDataSource.value)) {
      history.push(`/2.0/externalapi/${version}/v/${projectId}/edit/${externalApiId}`);
    } else {
      history.push(`/2.0/externalapi/${version}/v/${projectId}/edit-external-source/${externalApiId}`);
    }
    window.location.reload();
  };

  generateOptions = (externalDatabase) => {
    function createLabelContent(el, imagePath) {
      const datasourceType = datasourceTypeLabel(el.type);
      return (
        <span>
          <img src={imagePath} width="18" height="18" className="no-wh" alt={el.type} />
          &nbsp;
          {datasourceType}
        </span>
      );
    }

    let options = [];
    let typeSet = new Set();

    externalDatabase.forEach((el) => {
      if (!typeSet.has(el.type)) {
        let images = apiTypeImages[el.type];
        let imagePath = require(`../../../common/dataSource/img/${images}`);
        let labelContent = createLabelContent(el, imagePath);

        options.push({
          label: labelContent,
          value: el.type,
        });

        typeSet.add(el.type);
      }
    });

    let labelObj = this.generateCustomLabel(REST_API);
    options.push(labelObj);

    return options;
  };

  generateCustomLabel = (name) => {
    function createLabelContent(name, imagePath) {
      const datasourceType = datasourceTypeLabel(name);
      return (
        <span>
          <img src={imagePath} width="18" height="18" className="no-wh" alt={name} />
          &nbsp;
          {datasourceType}
        </span>
      );
    }

    let images = apiTypeImages[name];
    let imagePath = require(`../../../common/dataSource/img/${images}`);
    let labelContent = createLabelContent(name, imagePath);
    return {
      label: labelContent,
      value: name,
    };
  };

  renderExternalApiTypeModal = () => {
    if (!this.state.showmodal) {
      return null;
    }
    const { externalApiType, externalapi } = this.props;
    const { externalDatabase } = externalapi;
    let options = this.generateOptions(externalDatabase);
    console.log('🚀 ~ RestAPIExternalSourceForm ~ renderExternalApiTypeModal ~ options:', options);
    let labelObj = this.generateCustomLabel(externalApiType);

    return (
      <CommonModalComponent
        showModal={this.state.showmodal}
        toggleModal={this.toggleModal}
        modalHeader={'External API Type'}
        modalSize={'modal-md'}
      >
        <Formik
          initialValues={{
            externalDataSource: labelObj,
          }}
          onSubmit={this.handleExternalApiType}
        >
          {({ values, setFieldValue }) => (
            <Form className="form-horizontal">
              <div className="form-group">
                <FormFieldWithLabel
                  cta={false}
                  label=""
                  icon="select"
                  infoDescription={'Change External API Type'}
                >
                  <Field
                    name="fieldName"
                    render={({ field }) => (
                      <CustomSelect
                        name="externalDataSource"
                        isMulti={false}
                        onChange={setFieldValue}
                        options={options}
                        value={values.externalDataSource}
                      />
                    )}
                  />
                  <TooltipInfo
                    title={'Change External API Type'}
                    showHeader={true}
                    showArrow={true}
                    append={true}
                  />
                </FormFieldWithLabel>
              </div>
              <div className="text-right">
                {' '}
                <button type="submit" className="btn btn-theme-submit btn-md">
                  <i className="wb webconnect-save-regular" /> Update
                </button>
              </div>
            </Form>
          )}
        </Formik>
      </CommonModalComponent>
    );
  };

  render() {
    const {
      params,
      bodyType,
      bodyData,
      bodyRawData,
      headers,
      authType,
      accessToken,
      requestHeader,
      nameError,
      urlError,
      bodyDataFrom,
      sendFormData,
      currentUserParams,
      enableAuthorization,
      collectionMapping,
      collectionName,
      selectedCollectionName,
      processResponse,
      exportResponse,
      processResponseDataMapping,
      exportItemsPath,
      exportFileName,
      generateCSV,
      errors,
      timeout,
      errorCollapse,
      timeoutCollapse,
      bodyRawJSON,
      bodyCustomJSON,
      requestDataJsonType,
      highlightFields,
      jsonEditor,
      sendCollectionData,
      selectedCollection,
      showCurrentUserMapping,
      bodyCollectionMapping,
      statusPath,
      selectedMapping,
      isUpdateItemWithResponse,
      donotPersistResponseData,
    } = this.state;
    let { itemsPath } = this.state;
    const {
      version,
      externalApiId,
      externalApiType,
      projectId,
      externalapi,
      actions,
      home,
      common,
    } = this.props;
    const { responseData, externalDatabase } = externalapi;
    if (responseData && responseData.length > 0 && responseData[0].hasOwnProperty('documents')) {
      itemsPath = responseData.some((obj) => obj.documents && obj.documents.length > 0)
        ? 'documents'
        : itemsPath;
    }
    if (responseData && responseData.length > 0 && responseData[0].hasOwnProperty('records')) {
      itemsPath = responseData[0].hasOwnProperty('records') ? 'records' : itemsPath;
    }
    const { showCollectionMapping } = actions;

    return (
      <>
        {this.state.showModalForCollectionFields && this.showCollectionFieldModal()}
        <div className="row mx-auto">
          <ParentContentCard
            icon={externalApiType === REST_API ? 'ExternalAPIs' : ''}
            title={getDatasourceName(externalApiType)}
            datasourceIconSvg={externalApiType === REST_API ? '' : externalApiType}
            headerText="Change Type"
            headerButton={externalDatabase.length > 0 ? this.toggleModal : ''}
          >
            {this.renderExternalApiTypeModal()}
            <ExternalSourceInfo version={version} projectId={projectId} />
            <div className="row pb-3">
              <div className="col-6">
                <CustomInputWithIcon icon="text">
                  <input
                    type="text"
                    name="externalApiName"
                    className="form-control form-control-sm"
                    onChange={this.handleChange}
                    value={this.state.externalApiName}
                    placeholder="Name"
                  />
                  {nameError && <p className="errors">{nameError}</p>}
                </CustomInputWithIcon>
              </div>
              <div className="col-6">
                <CustomInputWithIcon icon="select" title="Select Request Type">
                  <select
                    name="methodType"
                    onChange={this.handleChange}
                    value={this.state.methodType}
                    className="form-control form-control-sm custom-select-sm"
                    disabled
                  >
                    <option key={this.state.methodType} value={this.state.methodType}>
                      {this.state.methodType}
                    </option>
                  </select>
                </CustomInputWithIcon>
              </div>
              {/* // Hide the URL input field for MySQL external API type */}
              <div className={`col-md-12 col-lg-12 ${externalApiType === MYSQL ? 'd-none' : ''}`}>
                <CustomInputWithIcon icon="url" title="URL">
                  <input
                    id="url"
                    name="url"
                    type="text"
                    className="form-control form-control-sm"
                    onChange={this.handleChange}
                    value={this.state.url}
                    placeholder="External API URL"
                  />
                  <div className="input-group-append">
                    <span className="input-group-text">
                      <button
                        type="button"
                        className="btn btn-theme-submit btn-xs btn-icon-only"
                        title="Add Fields"
                        onClick={() => this.toggleFieldsModal()}
                      >
                        <i className="wb webconnect-plus" />
                      </button>
                    </span>
                  </div>
                  {urlError && <p className="errors">{urlError}</p>}
                </CustomInputWithIcon>
              </div>
              <div className={`col-md-12 col-lg-12 ${externalApiType === MYSQL ? 'd-none' : ''}`}>
                <br />
                <hr />
                <br />
                <h4 className="card-title px-3">
                  Request Data Mapping
                  <br />
                  <small>( You can send dynamic data in request )</small>
                </h4>
              </div>
              {/* do not show this part to client ussing css to hide d-none */}
              <div className="row col-12 d-none">
                <div className="col-6">
                  <div className="form-check px-3">
                    <CustomRadio label="Send Collection Data" isRadio={false}>
                      <input
                        name="sendCollectionData"
                        type="checkbox"
                        className="form-check-input"
                        checked={sendCollectionData}
                        onChange={this.handleCheckboxChange}
                      />
                    </CustomRadio>
                    <small>( We will send Collection Data in request )</small>
                  </div>
                </div>
                <div className="col-6">
                  {sendCollectionData &&
                  requestDataJsonType &&
                  ['DEFAULT', 'CUSTOM', 'FORM_DATA', 'FORM_URL_ENCODED'].includes(
                    requestDataJsonType,
                  ) ? (
                    <div className="form-group mt-2">
                      <div className="input-group">
                        <div className="input-group-prepend" title={'Choose Collections'}>
                          <span className="input-group-text">
                            <i className={`wb ${iconForField('select')}`}></i>
                          </span>
                        </div>
                        <select
                          name="selectedCollectionName"
                          className="form-control form-control-sm custom-select-sm"
                          value={collectionName}
                          onChange={this.handleCollectionChange}
                        >
                          <option value="">- Choose Collection -</option>
                          {this.collectionsOptions().map((collection) => (
                            <option key={collection.value} value={collection.value}>
                              {collection.label}
                            </option>
                          ))}
                        </select>
                      </div>
                    </div>
                  ) : (
                    ''
                  )}
                </div>
              </div>
              <div className={`col-md-12 col-lg-12 ${externalApiType === MYSQL ? 'd-none' : ''}`}>
                <ExternalSourceFormTabBar
                  externalapi={externalapi}
                  createNewParamRow={this.createNewParamRow}
                  handleBodyData={this.handleBodyData}
                  handleRawData={this.handleRawData}
                  handleHeaderChange={this.handleHeaderChange}
                  handleAuthData={this.handleAuthData}
                  createNewParamRowForUser={this.createNewParamRowForUser}
                  bodyType={bodyType}
                  params={params}
                  bodyData={bodyData}
                  bodyRawData={bodyRawData}
                  headers={headers}
                  authType={authType}
                  accessToken={accessToken}
                  requestHeader={requestHeader}
                  currentUserParams={currentUserParams}
                  selectedCollectionName={collectionName}
                  bodyDataFrom={bodyDataFrom}
                  home={home}
                  projectDetail={common.projectDetail}
                />
              </div>
              <div className="col-md-12 col-lg-12">
                <ExternalSourceCollectionMapping
                  handleChange={this.handleCollectionFormChange}
                  externalapi={externalapi}
                  externalApiId={externalApiId}
                  externalApiType={externalApiType}
                  selectedCollectionName={collectionName}
                  collectionMapping={collectionMapping}
                  bodyDataFrom={bodyDataFrom}
                  toggleSendFormData={this.toggleSendFormData}
                  sendFormData={sendFormData}
                  selectBodyDataFrom={this.selectBodyDataFrom}
                  bodyRawJSON={bodyRawJSON}
                  bodyCustomJSON={bodyCustomJSON}
                  handleBodyRawJSON={this.handleBodyRawJSON}
                  handleBodyCustomJSON={this.handleBodyCustomJSON}
                  requestDataJsonType={requestDataJsonType}
                  toggleHighlightFields={this.toggleHighlightFields}
                  highlightFields={highlightFields}
                  jsonEditor={jsonEditor}
                  handleJsonEditor={this.handleJsonEditor}
                  sendCollectionData={sendCollectionData}
                  selectedCollection={selectedCollection}
                  bodyCollectionMapping={bodyCollectionMapping}
                  processResponseDataMapping={processResponseDataMapping}
                  methodType={this.state.methodType}
                  projectDetail={common.projectDetail}
                />
              </div>
              <hr />
              {![MYSQL].includes(externalApiType) && this.showSendRequestOrMockData()}
              <hr />
              {this.showMockDataMapping()}
              <div className="col-md-12 col-lg-12">
                <ShowResponseDataApi
                  responseData={responseData}
                  handleBtnClick={showCollectionMapping}
                />
              </div>
              <div className="col-12">
                <hr />
                <div className="text-right">
                  <button
                    className="btn btn-outline-primary btn-sm"
                    onClick={() => this.setState({ errorCollapse: !errorCollapse })}
                  >
                    <i className={`wb ${drapcodeIcon('error')}`}></i> Error Handling
                  </button>
                  <button
                    className="btn btn-outline-primary btn-sm"
                    onClick={() => this.setState({ timeoutCollapse: !timeoutCollapse })}
                  >
                    <i className={`wb ${drapcodeIcon('timeout')}`}></i> Timeout Handling
                  </button>
                </div>
                <Collapse isOpen={errorCollapse}>
                  {errors.map((error) => (
                    <div key={error.id} className="p-1 border-bottom">
                      <ExternalApiError error={error} createNewErrorRow={this.createNewErrorRow} />
                    </div>
                  ))}
                </Collapse>
                <Collapse isOpen={timeoutCollapse}>
                  <TimeoutError handleAuthData={this.handleAuthData} timeout={timeout} />
                </Collapse>
                <hr />
              </div>
              {/* {this.showResponseMappingOptions()} */}
              {['PATCH', 'POST', 'DELETE', 'PATCH'].includes(this.state.methodType)
                ? ''
                : this.showResponseMappingOptions()}
              {this.enableAuthentication()}
              <hr />
              {enableAuthorization === 'AUTHENTICATION' && this.showCurrentUserMapping()}
              <hr />
              {processResponse && enableAuthorization === 'SAVE_TO_COLLECTION' && (
                <>
                  <div className="col-12">
                    <ExternalSourceResponseDataMapping
                      handleChange={this.handleResponseDataChange}
                      statusPath={statusPath}
                      itemsPath={itemsPath}
                      selectedCollectionName={selectedCollectionName}
                      selectedMapping={selectedMapping}
                      customPrimaryKey={this.props.customPrimaryKey}
                      requestMappingSelectedCollection={collectionName}
                      isUpdateItemWithResponse={isUpdateItemWithResponse}
                      donotPersistResponseData={donotPersistResponseData}
                      processResponseDataMapping={processResponseDataMapping}
                      responseData={responseData}
                      handleCheckboxChange={this.handleCheckboxChange}
                      showCurrentUserMapping={showCurrentUserMapping}
                      externalApiType={externalApiType}
                      externalDatabase={externalDatabase}
                    />
                  </div>
                  <hr />
                  {/* {this.enableCurrentUserMapping()} */}
                  {this.showCurrentUserMapping()}
                </>
              )}
              <div className="col-12">
                <ExportResponseFile
                  exportResponse={exportResponse}
                  generateCSV={generateCSV}
                  exportItemsPath={exportItemsPath}
                  exportFileName={exportFileName}
                  handleRadioChange={this.handleRadioChange}
                  handleAuthData={this.handleAuthData}
                />
              </div>
              <div className="col-12 text-right">
                {/* <button
                type="button"
                className="btn btn-md btn-cl mr-2"
                onClick={() => window.history.back()}
              >
                <i className={`wb ${drapcodeIcon('back')}`}></i>&nbsp;Back
              </button> */}
                <button className="btn btn-theme-submit" onClick={this.handleSubmit}>
                  <i className={`wb ${drapcodeIcon('save')}`}></i>
                  &nbsp;Save Setting&nbsp;
                </button>
              </div>
            </div>
          </ParentContentCard>
          <ParentDocCard>
            <h5>
              <b>About REST API</b>
            </h5>
            <p>
              You can create different REST APIs for different purposes. GET POST PUT PATCH DELETE
            </p>
            <br />
            <h5>
              <b>External APIs Success Message Configuration</b>
            </h5>
            <p>
              There are several scenarios where you may want to show the user the response of the
              API and a custom message when it returns the success.
            </p>
            <DocsLink link="https://academy.drapcode.com/docs/app-collection/external-apis-success-message-configuration" />
            <br />
            <h5>
              <b>Videos</b>
            </h5>
            <VideoBox
              heading="External APIs Success Message Configuration"
              imgLink="https://drapcode-static.s3.amazonaws.com/docs-img/%3EExternalAPIsSuccessMessage.jpg"
              videoLink="https://www.youtube.com/watch?v=at5z4bLq1mA"
            />
          </ParentDocCard>
        </div>
      </>
    );
  }
}

function mapStateToProps(state) {
  return {
    externalapi: state.externalapi,
    home: state.home,
    common: state.common,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ ...actions, ...commonActions }, dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(RestAPIExternalSourceForm);
